// extracted by mini-css-extract-plugin
export default {"card":"AmazonWorkbookCard_card__2pEhN"};